module.exports = __webpack_public_path__ + "img/undraw_success_factors_fay0.a786bfa8.png";